<div class="w-[1200px] flex flex-col gap-x-2">
  <h2 class="font-semibold text-lg">Произвольная локация</h2>
  <app-client-address-with-coordinates
    [address]="addressForm"
  ></app-client-address-with-coordinates>
  <div class="flex gap-x-2 justify-end">
    <button
      (click)="context.$implicit.complete()"
      size="m"
      appearance="outline"
      tuiButton
      class="mr-2"
    >
      Отмена
    </button>
    <button
      (click)="applyLocation()"
      [disabled]="!addressForm.valid"
      tuiButton
      size="m"
    >
      Применить
    </button>
  </div>
</div>
